export default __webpack_public_path__ + "static/media/kristina_savova_l.367cb8fa.jpg";